import { useHistory, useParams } from "react-router";
import {Link} from 'react-router-dom';
import useFetch from "./useFetch";

const BlogDetails = () => {
  const { id } = useParams();
  const { data: blog, error, isLoading } = useFetch(`https://posts-rest.herokuapp.com/posts/${id}`);
  const history = useHistory();

  const handleDelete = () => {
    fetch(`https://posts-rest.herokuapp.com/posts/${id}`, {
      method: 'DELETE'
    })
    .then(() => {
      history.push('/');
    })
  }

  return (
    <div className="blog-details">
      {isLoading && <div>Loading...</div>}
      {error && <div>{error}</div>}
      {blog && (
        <article>
          <h2>{blog.title}</h2>
          <p>Written by {blog.author}</p>
          <div>{blog.body}</div>
          <button onClick={handleDelete}>Delete</button>
          <Link to={`/edit/${id}`}>
            <button>Edit</button>
          </Link>
        </article>
      )}
    </div>
  );
}
 
export default BlogDetails;